<script lang="ts">
	import later from "../libs/time/later";
	import toISOString from "../libs/date/format";

	export let closeModal: any;
	export let saveCallback: Function;

	let scheduledDate = toISOString(new Date(), false);
	let scheduledTime;

	$: disabledSave = !scheduledTime;

	async function saveScheduledTime() {
		if (!scheduledDate) {
			scheduledDate = toISOString(new Date(), false);
		}

		saveCallback(scheduledDate + " " + scheduledTime);
		closeModal();
	}
</script>

<div class="modal-backdrop-custom" />

<div class="modal">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">Volať neskôr</div>

			<div class="modal-body">
				<form class="row g-3">
					<div class="col-md-6 mb-3">
						<label for="date" class="form-label">Dátum</label>
						<input type="date" class="form-control" id="date" bind:value={scheduledDate} />
					</div>

					<div class="col-md-6 mb-3">
						<label for="time" class="form-label">Čas</label>
						<input type="time" class="form-control" id="time" bind:value={scheduledTime} />
					</div>

					<div class="col-md-12">
						<div class="btn-group" role="group">
							<button
								type="button"
								class="btn btn-primary"
								on:click|preventDefault={() => {
									scheduledTime = later(15);
								}}>o 15 minút</button
							>
							<button
								type="button"
								class="btn btn-primary"
								on:click|preventDefault={() => {
									scheduledTime = later(30);
								}}>o 30 minút</button
							>
							<button
								type="button"
								class="btn btn-primary"
								on:click|preventDefault={() => {
									scheduledTime = later(60);
								}}>o hodinu</button
							>
						</div>
					</div>
				</form>
			</div>

			<div class="modal-footer">
				<button class="btn btn-primary" on:click={saveScheduledTime} disabled={disabledSave}>Naplánovať</button>
				<button class="btn btn-secondary" on:click={closeModal}>Zrušiť</button>
			</div>
		</div>
	</div>
</div>

<style>
	.modal-backdrop-custom:before {
		content: "";
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: #000;
		opacity: 0.7;
	}

	.modal {
		display: block;
	}
</style>
